<template>
  <tr class="">
    <td class="p-t-5 p-b-5 v-align-middle" :data-label="$t('UserNoticePreferences.contact_me_when')">
      {{ notice.title }}
      <div class="service-selection">
        <label>SERVICE</label>
        <multiselect v-model="selectedServices"
                          track-by="id"
                          label="name"
                          :options="services"
                          :group-select="true"
                          :group-label="entityHasHubs ? 'hub' : ''"
                          :group-values="entityHasHubs ? 'services' : ''"
                          :placeholder="$t('multiselect.placeholder')"
                          :showLabels="false"
                          :allow-empty="true"
                          :multiple="true"
                          :hide-selected="true" />
      </div>
    </td>
    <td class="checkbox-notice-preference p-t-5 p-b-5 v-align-middle">
      <div class="checkbox check-primary">
        <input type="checkbox" :id="notice.name" v-model="activeMail">
        <label :for="notice.name"></label>
      </div>
    </td>
  </tr>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: "NoticePreferencesWithServicesRow",
  props: ['notice', 'currentUser', 'entity'],
  data() {
    return {
      selectedServices: [],
      activeMail: false
    }
  },
  computed: {
    ...mapGetters({
      manageableServices: 'users/manageableServices',
      servicesMail: 'users/servicesMail'
    }),
    services() {
      if(!this.entityHasHubs) {
        return this.manageableServices;
      }
      return this.buildServicesListGroupedByHubs();
    },
    entityHasHubs() {
      return this.entity.hubs.length > 1
    },
    availableHubs() {
      return this.currentUser.hubs.filter((hub) => hub.entity_id == this.entity.id);
    }
  },
  watch: {
    selectedServices(newValue,_) {
      this.servicesMail[this.notice.name].services = newValue
    },
    activeMail(newValue,_) {
      this.servicesMail[this.notice.name].active = newValue
    },
    entity(newValue,_) {
      this.initManageableOptionsAction({ entityId: newValue.id })
    }
  },
  methods: {
    ...mapActions({
      initManageableOptionsAction: 'users/initManageableOptions',
      loadServicesMail: 'users/loadServicesMail'
    }),
    buildServicesListGroupedByHubs() {
      return this.availableHubs.map(hub => {
        return {
          hub: hub.name,
          services: this.manageableServices.filter(service => service.hub_id == hub.id)
        }
      });
    },
  },
  async mounted() {
    await this.loadServicesMail()
    await this.initManageableOptionsAction({ entityId: this.entity.id })

    this.activeMail = this.servicesMail[this.notice.name].active
    this.selectedServices = this.servicesMail[this.notice.name].services
  }
}
</script>

<style scoped>
.service-selection {
  display: flex;
  align-items: center;
  margin-top: 5px;
  .multiselect {
    margin-left: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/users/NoticePreferencesWithServicesRow.vue